import type { EntityStatusTone } from '../../../components/entity-detail/EntityStatusChip.js';
import { formatDate, formatDateTime } from '../../../shared/format/index.js';
import type { ProjectStatus } from '../api/projects.client.js';
import { i18n } from '../../../i18n/index.js';

export { formatDate, formatDateTime };

export function getProjectStatusLabel(status: ProjectStatus): string {
  return i18n.t(`crm.features.project.status.${status}`);
}

export function getProjectStatusOptions(): Array<{ value: ProjectStatus; label: string }> {
  return (['planned', 'active', 'on_hold', 'completed', 'cancelled'] as const).map((value) => ({
    value,
    label: getProjectStatusLabel(value),
  }));
}

// antd Tag color tokens.
export const STATUS_TONE: Record<ProjectStatus, EntityStatusTone> = {
  planned: 'default',
  active: 'processing',
  on_hold: 'warning',
  completed: 'success',
  cancelled: 'default',
};

export const STATUS_ORDER: Record<ProjectStatus, number> = {
  planned: 0,
  active: 1,
  on_hold: 2,
  completed: 3,
  cancelled: 4,
};

type MemberLike =
  | { user: { name: string; email: string } }
  | { name?: string | null; email: string }
  | null
  | undefined;

export function memberName(member: MemberLike): string {
  if (!member) return '—';
  if ('user' in member && member.user) {
    return member.user.name.trim() || member.user.email;
  }
  const flat = member as { name?: string | null; email: string };
  return (flat.name ?? '').trim() || flat.email;
}
